import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { Cycle } from "@/react/types/UsageBilling";

export interface ConversationConsumption extends Record<string, unknown> {
  community_member_avatar_url: string | null;
  community_member_email: string | null;
  community_member_name: string | null;
  conversation_id: number;
  conversation_title: string;
  project_id: number | null;
  project_name: string | null;
  total_credits: number;
}

export interface AiCreditsConsumptionResponse {
  by_conversation: ConversationConsumption[];
}

export interface ConversationOption {
  conversation_id: number;
  conversation_title: string;
}

export interface MemberOption {
  member_email: string;
  member_id: number;
  member_name: string;
}

export interface ProjectOption {
  project_id: number;
  project_name: string;
}

export interface DailyConsumption {
  addon: number;
  date: string;
  plan_allowance: number;
  reward: number;
  rollover: number;
  top_up: number;
}

export interface AiCreditsDailyConsumptionResponse {
  by_day: DailyConsumption[];
}

const fetchConsumption = (params: {
  start_date: string;
  end_date: string;
  filters?: {
    conversation_ids?: number[];
    member_ids?: number[];
    project_ids?: number[];
  };
}): Promise<AiCreditsConsumptionResponse> =>
  reactQueryGet<AiCreditsConsumptionResponse>(
    internalApi.credits.aiCreditsConsumption.show(params),
  );

const fetchConversations = (params: {
  start_date: string;
  end_date: string;
  page?: number;
}): Promise<ConversationOption[]> =>
  reactQueryGet<ConversationOption[]>(
    internalApi.credits.aiCreditsConversations.index(params),
  );

const fetchMembers = (params: {
  start_date: string;
  end_date: string;
}): Promise<MemberOption[]> =>
  reactQueryGet<MemberOption[]>(
    internalApi.credits.aiCreditsMembers.index(params),
  );

const fetchCycles = (): Promise<{ records: Cycle[] }> =>
  reactQueryGet<{ records: Cycle[] }>(internalApi.credits.cycles.index());

const fetchProjects = (params: {
  start_date: string;
  end_date: string;
}): Promise<ProjectOption[]> =>
  reactQueryGet<ProjectOption[]>(
    internalApi.credits.aiCreditsProjects.index(params),
  );

const fetchDailyConsumption = (params: {
  start_date: string;
  end_date: string;
  filters?: {
    conversation_ids?: number[];
    member_ids?: number[];
    project_ids?: number[];
  };
}): Promise<AiCreditsDailyConsumptionResponse> =>
  reactQueryGet<AiCreditsDailyConsumptionResponse>(
    internalApi.credits.aiCreditsDailyConsumption.show(params),
  );

export const aiCreditsConsumptionApi = {
  fetchConsumption,
  fetchConversations,
  fetchDailyConsumption,
  fetchMembers,
  fetchProjects,
  fetchCycles,
};
